module.exports = __webpack_public_path__ + "static/impact-daos-b46346ae0ca67d0e6c30d12f0d6f1dab.png";